import { Icon, IconProps } from "@chakra-ui/react";

export function CalendarIcon({ ...rest }: IconProps) {
  return (
    <Icon
      width="29px"
      height="27px"
      viewBox="0 0 29 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M21.7516 4.5H7.49226C4.86718 4.5 2.73914 6.51472 2.73914 9V20.25C2.73914 22.7353 4.86718 24.75 7.49226 24.75H21.7516C24.3767 24.75 26.5048 22.7353 26.5048 20.25V9C26.5048 6.51472 24.3767 4.5 21.7516 4.5Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.73914 11.25H26.5048M9.86882 2.25V6.75V2.25ZM19.3751 2.25V6.75V2.25Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}

export function Calendar2Icon({ ...rest }: IconProps) {
  return (
    <Icon
      width="14px"
      height="14px"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_429_101)">
        <path
          d="M1.32983 7.00004C1.32983 4.92599 1.32983 3.88869 1.97435 3.24464C2.61832 2.60004 3.65549 2.60004 5.72928 2.60004H7.929C10.0028 2.60004 11.04 2.60004 11.6839 3.24464C12.3284 3.88869 12.3284 4.92599 12.3284 7.00004V8.10004C12.3284 10.1741 12.3284 11.2114 11.6839 11.8554C11.04 12.5 10.0028 12.5 7.929 12.5H5.72928C3.65549 12.5 2.61832 12.5 1.97435 11.8554C1.32983 11.2114 1.32983 10.1741 1.32983 8.10004V7.00004Z"
          stroke="#4E5762"
          strokeWidth="1.2"
        />
        <path
          d="M4.07942 2.60002V1.77502M9.57872 2.60002V1.77502M1.60474 5.35002H12.0534"
          stroke="#4E5762"
          strokeWidth="1.2"
          strokeLinecap="round"
        />
        <path
          d="M10.1293 9.75C10.1293 9.89587 10.0714 10.0358 9.96821 10.1389C9.86506 10.2421 9.72517 10.3 9.5793 10.3C9.43343 10.3 9.29353 10.2421 9.19039 10.1389C9.08724 10.0358 9.0293 9.89587 9.0293 9.75C9.0293 9.60413 9.08724 9.46424 9.19039 9.36109C9.29353 9.25795 9.43343 9.2 9.5793 9.2C9.72517 9.2 9.86506 9.25795 9.96821 9.36109C10.0714 9.46424 10.1293 9.60413 10.1293 9.75ZM10.1293 7.55C10.1293 7.69587 10.0714 7.83576 9.96821 7.93891C9.86506 8.04205 9.72517 8.1 9.5793 8.1C9.43343 8.1 9.29353 8.04205 9.19039 7.93891C9.08724 7.83576 9.0293 7.69587 9.0293 7.55C9.0293 7.40413 9.08724 7.26424 9.19039 7.16109C9.29353 7.05795 9.43343 7 9.5793 7C9.72517 7 9.86506 7.05795 9.96821 7.16109C10.0714 7.26424 10.1293 7.40413 10.1293 7.55ZM7.3793 9.75C7.3793 9.89587 7.32135 10.0358 7.21821 10.1389C7.11506 10.2421 6.97517 10.3 6.8293 10.3C6.68343 10.3 6.54353 10.2421 6.44039 10.1389C6.33724 10.0358 6.2793 9.89587 6.2793 9.75C6.2793 9.60413 6.33724 9.46424 6.44039 9.36109C6.54353 9.25795 6.68343 9.2 6.8293 9.2C6.97517 9.2 7.11506 9.25795 7.21821 9.36109C7.32135 9.46424 7.3793 9.60413 7.3793 9.75ZM7.3793 7.55C7.3793 7.69587 7.32135 7.83576 7.21821 7.93891C7.11506 8.04205 6.97517 8.1 6.8293 8.1C6.68343 8.1 6.54353 8.04205 6.44039 7.93891C6.33724 7.83576 6.2793 7.69587 6.2793 7.55C6.2793 7.40413 6.33724 7.26424 6.44039 7.16109C6.54353 7.05795 6.68343 7 6.8293 7C6.97517 7 7.11506 7.05795 7.21821 7.16109C7.32135 7.26424 7.3793 7.40413 7.3793 7.55ZM4.6293 9.75C4.6293 9.89587 4.57135 10.0358 4.46821 10.1389C4.36506 10.2421 4.22517 10.3 4.0793 10.3C3.93343 10.3 3.79353 10.2421 3.69039 10.1389C3.58724 10.0358 3.5293 9.89587 3.5293 9.75C3.5293 9.60413 3.58724 9.46424 3.69039 9.36109C3.79353 9.25795 3.93343 9.2 4.0793 9.2C4.22517 9.2 4.36506 9.25795 4.46821 9.36109C4.57135 9.46424 4.6293 9.60413 4.6293 9.75ZM4.6293 7.55C4.6293 7.69587 4.57135 7.83576 4.46821 7.93891C4.36506 8.04205 4.22517 8.1 4.0793 8.1C3.93343 8.1 3.79353 8.04205 3.69039 7.93891C3.58724 7.83576 3.5293 7.69587 3.5293 7.55C3.5293 7.40413 3.58724 7.26424 3.69039 7.16109C3.79353 7.05795 3.93343 7 4.0793 7C4.22517 7 4.36506 7.05795 4.46821 7.16109C4.57135 7.26424 4.6293 7.40413 4.6293 7.55Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_429_101">
          <rect
            width="13.1983"
            height="13.2"
            fill="white"
            transform="translate(0.229736 0.400024)"
          />
        </clipPath>
      </defs>
    </Icon>
  );
}
